import apiClient from '../client';
import type {
  PriceSuggestionRequest, PriceSuggestionResponse, YieldEstimateResponse,
  ScenarioNarrativeRequest, ScenarioNarrativeResponse, NewOperationYieldEstimateRequest,
  SalesPlanRequest, SalesPlanResponse, EstimateChatRequest, EstimateChatResponse,
} from '../../types';

const aiAdvisorService = {
  suggestPrice: async (data: PriceSuggestionRequest) => {
    const response = await apiClient.post<PriceSuggestionResponse>('/ai/suggest-price', data);
    return response.data;
  },

  estimateYield: async (farmOperationId: string) => {
    const response = await apiClient.post<YieldEstimateResponse>(`/ai/farm-operations/${farmOperationId}/estimate-yield`);
    return response.data;
  },

  chatAboutEstimate: async (farmOperationId: string, data: EstimateChatRequest) => {
    const response = await apiClient.post<EstimateChatResponse>(`/ai/farm-operations/${farmOperationId}/estimate-chat`, data);
    return response.data;
  },

  estimateYieldForNewOperation: async (data: NewOperationYieldEstimateRequest) => {
    const response = await apiClient.post<YieldEstimateResponse>('/ai/estimate-yield-for-new-operation', data);
    return response.data;
  },

  buildSalesPlan: async (data: SalesPlanRequest) => {
    const response = await apiClient.post<SalesPlanResponse>('/ai/sales-plan', data);
    return response.data;
  },

  getScenarioNarrative: async (data: ScenarioNarrativeRequest) => {
    const response = await apiClient.post<ScenarioNarrativeResponse>('/ai/scenario-narrative', data);
    return response.data;
  },
};

export default aiAdvisorService;
